import { getGraphQLClient } from 'utils/graphQL/client';
import {
  GET_YARDS,
  SEARCH_YARDS_BY_NAME_AND_ADDRESS,
} from 'utils/graphQL/queries/yardService';
import {
  ADD_YARD,
  UPDATE_YARD,
  DELETE_YARD,
} from 'utils/graphQL/mutations/yardService';
import { remapData } from 'utils/graphQL/utils';

export const YardClient = getGraphQLClient({
  url: YARD_SERVICE_URL,
});

export async function getYards(sortBy, sortOrder, skip, limit, yardInput) {
  try {
    return await YardClient.query({
      query: GET_YARDS,
      variables: {
        sortBy,
        sortOrder,
        skip,
        limit,
        yardInput,
      },
    });
  } catch (e) {
    console.error('Error during getYards: ', e.message);
    return { errors: [e] };
  }
}

export async function addYard(data) {
  try {
    return await YardClient.mutate({
      mutation: ADD_YARD,
      variables: data,
    });
  } catch (e) {
    console.error('Error during addYard: ', e.message);
    return { errors: [e] };
  }
}

export async function updateYard(data) {
  try {
    return await YardClient.mutate({
      mutation: UPDATE_YARD,
      variables: data,
    });
  } catch (e) {
    console.error('Error during updateYard: ', e.message);
    return { errors: [e] };
  }
}

export async function deleteYard(id) {
  try {
    return await YardClient.mutate({
      mutation: DELETE_YARD,
      variables: {
        id,
      },
    });
  } catch (e) {
    console.error('Error during deleteYard: ', e.message);
    return { errors: [e] };
  }
}

export async function searchYardsByNameAndAddress(
  searchText,
  sortBy,
  sortOrder,
  offset,
  limit,
) {
  try {
    return await YardClient.query({
      query: SEARCH_YARDS_BY_NAME_AND_ADDRESS,
      variables: {
        searchText,
        sortBy,
        sortOrder,
        offset,
        limit,
      },
    });
  } catch (e) {
    console.error('Error during searchYardsByNameAndAddress: ', e.message);
    return { errors: [e] };
  }
}

export function remapResponseHandler(mutateFunc, dataKey) {
  return async (data) => {
    const result = await mutateFunc({ variables: data });

    return remapData(result, dataKey);
  };
}
